function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Already Paid
 * 
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './AlreadyPaid.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class AlreadyPaid extends Component {
  render() {
    const {
      referrer
    } = this.props.application;
    return /*#__PURE__*/_jsxs("div", {
      className: "AlreadyPaid",
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Order successful"
      }), /*#__PURE__*/_jsx("p", {
        children: "Your IDP order has been completed successfully."
      }), /*#__PURE__*/_jsx("div", {
        className: "footer",
        children: /*#__PURE__*/_jsxs("div", {
          className: "button restart",
          onClick: () => {
            window.location = referrer;
          },
          tabIndex: "0",
          role: "button",
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: "redo",
            className: "left"
          }), "Apply for another IDP"]
        })
      })]
    });
  }
}
_defineProperty(AlreadyPaid, "defaultProps", {
  application: {
    referrer: 'https://www.internationaldrivingpermit.com.au/'
  }
});
const mapStateToProps = ({
  application
}) => {
  return {
    application
  };
};
const VisibleAlreadyPaid = connect(mapStateToProps)(AlreadyPaid);
export default VisibleAlreadyPaid;